import { AppImpl } from "core/controller/App"

export const useAppName = () => AppImpl.theApp.name
